import axios from 'axios';

// Create axios instance with base URL
const apiClient = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`
  // ✅ Removed Content-Type header to allow FormData uploads
});

// Add interceptor to include auth token in requests
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // ✅ Only set Content-Type for non-FormData requests
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  error => Promise.reject(error)
);

// Company service functions matching the backend routes
const companyService = {
  // List all companies (admin only)
  listCompanies: async () => {
    try {
      const response = await apiClient.get('/companies');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get a company by ID
  getCompanyById: async (id) => {
    try {
      const response = await apiClient.get(`/companies/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create a new company
  createCompany: async (companyData) => {
    try {
      const response = await apiClient.post('/companies', companyData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update an existing company
  updateCompany: async (id, companyData) => {
    try {
      const response = await apiClient.put(`/companies/${id}`, companyData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete a company
  deleteCompany: async (id) => {
    try {
      const response = await apiClient.delete(`/companies/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get LINE webhook URL for a company
  getLineWebhookUrl: async (companyId) => {
    try {
      const response = await apiClient.get(`/companies/${companyId}/line-webhook-url`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default companyService;
